import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { CHECKOUT_URL } from '../data/product';
const included = ['6 volumes · 300 landscape pages', '52 weekly classes (2-page spreads)', 'Every skill at 3 levels · ages 3–12', '31 printable worksheets', '5 bonuses, incl. the Placement Guide', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cloud text-ink" data-id="element-196" data-mp="1rsyieh5s4i16">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-197" data-mp="25sr581e6qe3v">
        <div className="text-center" data-id="element-198" data-mp="25pv4k5aydbbq">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-coral-deep" data-id="element-199" data-mp="20sv90obqbqyv">Complete package</p>
          <h2 id="pricing-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-200" data-mp="3h6bpuf96um6i">
            Your whole year of classes, planned
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-cloud-dark bg-white shadow-soft" data-id="element-201" data-mp="3w08ck3pope89">
          <div className="bg-ink px-5 py-5 text-center" data-id="element-202" data-mp="4s4ap8wqsngu">
            <h3 className="font-display text-lg font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-203" data-mp="9s8rz15h5m84">Rec Gymnastics Class-Ready — Complete Package</h3>
            <p className="mt-1 text-[13px] font-semibold uppercase tracking-widest text-amber" data-id="element-204" data-mp="eq0lfzlrpgef">6 Volumes + 5 Bonuses</p>
          </div>
          <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-205" data-mp="3d74g6al30n9y" />

          <div className="p-5 sm:p-7" data-id="element-206" data-mp="3i8boqbv1tqho">
            <div id="offer" className="scroll-mt-4 rounded-2xl bg-cloud px-[8%] py-8" data-id="element-207" data-mp="3n7euxzmrm2r8">
              <ProductVisual lazy className="w-[88%]" data-id="element-208" data-mp="3rxv8djql5odl" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-209" data-mp="3rz6dpnzoj46t">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-210" data-mp="2ugdbvnfybn2f">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-teal" data-id="element-211" data-mp="2zfzp3wvs53b8">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-212" data-mp="2reibai1fcnrp" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cloud-dark pt-6 text-center" data-id="element-213" data-mp="318qzitjf9uk2">
              <p className="text-[13px] text-slate" data-id="element-214" data-mp="2w83bmgqhptu2">
                Total value <span className="line-through" data-id="element-215" data-mp="28hh54tw4whm6">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-ink" data-id="element-216" data-mp="23ixi0q5t0zs8">
                <span className="mt-2.5 font-display text-3xl font-extrabold" data-id="element-217" data-mp="23la85qlpuggd">$</span>
                <span className="font-display text-[56px] font-extrabold leading-[0.9] sm:text-7xl" data-id="element-218" data-mp="2ie3lp6hfgmie">27</span>
                <span className="mt-3 text-[13px] font-semibold text-slate" data-id="element-219" data-mp="2djg6xzc876h0">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-220" data-mp="3tx69v2rlzop2">
                <span className="rounded-full bg-amber px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-221" data-mp="3ovz57ckrj5mm">Save $70</span>
                <span className="rounded-full border border-cloud-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-222" data-mp="5970sphx5wmc">One-time payment</span>
                <span className="rounded-full border border-cloud-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-223" data-mp="3nh68ibuohlhj">No app, no subscription</span>
              </div>

              <p className="mt-4 text-[13px] text-slate" data-id="element-224" data-mp="j2y9xwrqnehj">That&apos;s about 52 cents a class.</p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-225" data-mp="o22hyk2xf66a">
                Get Class-Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-slate" data-id="element-226" data-mp="e9wtvlfsp8wd">Backed by the 7-day money-back guarantee</p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-slate" data-id="element-227" data-mp="11zzfpjt49imj">
                <li className="flex items-center gap-1.5" data-id="element-228" data-mp="16qz9whaupmlc">
                  <LockIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-229" data-mp="16sagspzlfago" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-230" data-mp="3a7w4lqm7e2bj">
                  <ZapIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-231" data-mp="3aas5nntcl747" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-232" data-mp="318iwp2dq9lsx">
                  <ShieldCheckIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-233" data-mp="31a3ponke8woo" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-slate" data-id="element-234" data-mp="3o86zr5ujq32i">Price in USD. You&apos;ll be charged the equivalent in your local currency.</p>
      </div>
    </section>;
}